import { HStack, Text } from '@chakra-ui/react';
import CustomTitle from '@components/common/CustomTitle';
import { useAppSelector } from '@hooks/redux.hooks';
import { selectSituationTime } from '@redux/situation/situation.selectors';
import { format } from 'date-fns';
import { FormattedMessage } from 'react-intl';
type Props = {
  zone: string;
};

export default function PerimeterGridTitle({ zone }: Readonly<Props>) {
  const currentSituationTime = useAppSelector((state) => selectSituationTime(state, false));
  const currentSituationDate = currentSituationTime ? new Date(currentSituationTime) : null;
  return (
    <CustomTitle>
      <Text fontWeight="medium" textStyle="md" lineClamp={1} userSelect="none">
        {zone === 'default' ? <FormattedMessage id="perimeterCameras.defaultZone" /> : zone}
      </Text>
      {currentSituationDate && (
        <>
          <HStack gap={0}>
            <Text textStyle="md" fontWeight="medium" color="neutral.200">
              {format(currentSituationDate, 'HH:mm')}
            </Text>
            <Text textStyle="md" color="neutral.300">
              {format(currentSituationDate, ':ss')}
            </Text>
          </HStack>
          <Text textStyle="md" color="neutral.200">
            {format(currentSituationDate, 'dd/MM/yyyy')}
          </Text>
        </>
      )}
    </CustomTitle>
  );
}
